module.exports = __webpack_public_path__ + "02_face.553dc2ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer1/02_face.png
// module id = FnEw
// module chunks = 0